import * as React from "react"
import { batch } from "@preact/signals-react"
import { Box } from "@mui/material"
import { SwitchSeeker } from "@ui-seeker/core"

import { useAdminSkuMapping } from "../../@hooks"


export default function skipColumn() {
    return [{
        name: "skip", label: "Skip",
        options: {
            display: "excluded",
            customBodyRowRender: v => v ? "Yes" : "No"
        }
    }, {
        name: "skip", label: "Skip",
        options: {
            filter: false,
            customBodyRowRender: (value, rowData, _, updateValue) => <Box display="flex" justifyContent="center">
                <SkipCell
                    validated={value}
                    rowData={rowData}
                    updateValue={updateValue}
                />
            </Box>
        }
    }]
}

const SkipCell = ({ validated, rowData, updateValue }) => {
    const { handleSkip, isLoading } = useAdminSkuMapping(rowData)

    return <Box display="flex" justifyContent="center" className={isLoading ? "is-loading" : ""}>
        <SwitchSeeker
            formControlProps={{sx: { margin: "0 auto" }}}
            checked={!!validated}
            onChange={e => batch(() => {
                const newValue = e.target.checked
                updateValue(newValue)
                handleSkip(!newValue, updateValue)
            })}
        />
    </Box>
}